export const footerTranslations = {
  nl: {
    description: "Uw bestemming voor authentieke Indiase, Sri Lankaanse en Surinaamse voedselproducten, verse groenten en heerlijke gekookte maaltijden in Lelystad.",
    quickLinks: "Snelle Links",
    stayConnected: "Blijf Verbonden",
    whatsapp: "Word lid van WhatsApp Groep",
    googleReview: "Schrijf een Google Review",
    copyright: "© {currentYear} Ams Food Market. Alle rechten voorbehouden.",
    poweredBy: "Powered by LVS Webdevelopment",
  },
  en: {
    description: "Your destination for authentic Indian, Sri Lankan, and Surinamese food products, fresh vegetables, and delicious cooked meals in Lelystad.",
    quickLinks: "Quick Links",
    stayConnected: "Stay Connected",
    whatsapp: "Join WhatsApp Group",
    googleReview: "Write a Google Review",
    copyright: "© {currentYear} Ams Food Market. All rights reserved.",
    poweredBy: "Powered by LVS Webdevelopment",
  },
};